import React, { useState } from 'react'
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { CheckboxComponent, TextFieldComponent } from '../../components/CustomFormElement'
import validators from '../../utils/validators';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { paths } from '../../config/router.config';
import { EmailWhiteIcon, PasswordHideWhiteIcon, PasswordShowWhiteIcon, PhoneInputWhiteIcon } from '../../components/CustomIcons';
import theme from '../../theme.css';

const useStyles = makeStyles((theme) => ({
    link:{
        color: theme.palette.text.link,
        textDecoration: 'none',
    },
    button: {
        textTransform: 'capitalize!important',
        marginRight: theme.spacing(2) + '!important'
    }
}));


export default function ResetPasswordView(props){
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Form
            onSubmit={props.onReset}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item justify="center" alignItems="center">
                    <Grid xs={12} container item justify="center" alignItems="center">
                        <Box marginTop={5} marginBottom={5} style={{textAlign: 'center'}}>
                            <Typography variant="h4" color="primary">{t('forgot_password')}</Typography>
                            <Typography variant="subtitle1" style={{opacity: 0.6, marginTop: '5%'}}>{t('forgot_password_info')}</Typography>
                        </Box>
                    </Grid>
                    <Grid xs={12} item style={{ textAlign: 'center', width: '100%'}}>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="email"
                                component={TextFieldComponent}
                                placeholder={t('email_address')}
                                validate={validators.composeValidators(validators.validEmail)}
                            />
                        </Grid>

                        <Grid xs={12} item marginTop={3}>
                            <Box style={{textAlign: 'left'}}>
                                <Button variant="contained" color="primary" onClick={handleSubmit} className={classes.button}>{t('btn_send')}</Button>
                                <Button variant="text" onClick={props.onCancel} className={classes.button}>{t('btn_cancel')}</Button>
                            </Box>
                        </Grid>

                        {/* <Grid xs={12} item marginTop={5}>
                            <Link to={paths.login} className={classes.link} fullWidth>
                                {t('back_to_signin')}
                            </Link>
                        </Grid> */}
                    </Grid>
                </Grid>
            )} />
    );
}